// import Home from '@/views/about/list'
const Home = () => import('@/views/about/list')
// import FeedBack from '@/views/about/feedback'
const FeedBack = () =>  import('@/views/about/feedback')
// import Question from '@/views/about/question'
const Question = () =>  import('@/views/about/question')
// import Protocol from '@/views/about/protocol'
// import ReferralFunction from '@/views/about/refer'
const ReferralFunction = () =>  import('@/views/about/refer')

export default [
    {
        path: '',
        component: Home,
        meta: {
            title: '关于悠数学'
        }
    },
    {
        path: 'feedback',
        name: 'AboutFeedBack',
        component: FeedBack,
        meta: {
            title: '问题反馈'
        }
    },
    {
        path: 'question',
        name: 'AboutQuestion',
        component: Question,
        meta: {
            title: '常见问题'
        }
    },
    {
        path: 'protocol',
        name: 'Protocol',
        redirect: '/protocol/user'
    },
    {
        path: 'refer',
        name: 'ReferralFunction',
        component: ReferralFunction,
        meta: {
            title: '悠数学的正确姿势'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/about.js